import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import type { DiscountType } from '../enums/DiscountType'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'

export class DiscountOfferFilterEntity {
  type?: DiscountType
  minValue?: number
  maxValue?: number
  maxDiscountAllowed?: number
  firstPurchase?: boolean
  category?: CategoryMiniEntity
  user?: UserMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  startDate?: string
  endDate?: string
  branch?: BranchMiniEntity
}
 